import {
  Box, Grid, TextField, Typography, Checkbox,
  TableContainer, Table, TableHead, TableCell, TableBody,
  TableRow, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, Paper, FormControl, InputLabel,
  Select, MenuItem, Alert,
  Stack,
  Card,
  CardContent
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CreateStepperRaffleProps } from "../../../../domain/CreateStepperRaffleProps";
import { BANK_ACCOUNTS, BankAccountItem } from "../../../../constants/bankAccounts";
import { banks, getIconFromBankId } from "../../../../constants/banks";
import { BankAccount } from "../../bankAccounts";
import { getPrimaryColorByAccountId, getThemeByAccountId } from "../../../../utils/styleConstants";


export const BankAccountSteps = ({
  resource,
  setResource,
  setDisableNext,
  accountId,
}: CreateStepperRaffleProps) => {
  const initialBankAccounts = BANK_ACCOUNTS.find(
    (account) => account.accountId === accountId
  )?.bankAccounts || [];

  const [bankAccounts, setBankAccounts] = useState<BankAccountItem[]>(resource.bankAccounts && resource.bankAccounts.length > 0 ? resource.bankAccounts : initialBankAccounts);
  const [openDialog, setOpenDialog] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editedAccount, setEditedAccount] = useState<BankAccountItem | null>(null);

  const handleEditOpen = (index: number) => {
    setEditIndex(index);
    setEditedAccount({ ...bankAccounts[index] });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditedAccount(null);
    setEditIndex(null);
  };

  const handleSaveDialog = () => {
    if (editIndex !== null && editedAccount) {
      console.log("editIndex =>", editIndex)
      console.log("editedAccount =>", editedAccount)
      const updatedAccounts = bankAccounts.map((acc, i) =>
        i === editIndex ? { ...editedAccount } : acc
      );
      setBankAccounts(updatedAccounts);
    }
    handleCloseDialog();
  };

  const [selectedTicket, setSelectedTicket] = useState<number>(0);

  useEffect(() => {
    setResource((prevResource) => ({
      ...prevResource,
      bankAccounts
    }));
  }, [bankAccounts, setResource]);

  return (
    <Box p={2}>
      <Grid container>
        <Grid p={2}>
         <Stack
              spacing={2}
              display={"flex"}
              direction={"row"}
              justifyContent={"space-between"}
            >
              {[3, 5, 10].map((addition: number) => (
                <Card
                  key={addition}
                  sx={{
                    cursor: "pointer",
                    border: addition !== 20 ? "1px solid secondary.main" : "1px solid green",
                    borderRadius: "10px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    backgroundColor: `${getPrimaryColorByAccountId(accountId)}`,
                  }}
                  onClick={() => setSelectedTicket(addition)}
                >
                  <CardContent>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, padding: 0, color: `${getThemeByAccountId(accountId) === 'dark' ? '#000 !important' : '#FFF !important' }`, }}
                    >
                      {`${addition} Ticket`}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
          </Stack>
        </Grid>
      </Grid>
      <Grid container>
        {  
          bankAccounts.map((bankAccount, index) => (
            <Grid xs={3} sm={3} xl={3}>
              <Button onClick={() => handleEditOpen(index)} fullWidth>
                <BankAccount item={bankAccount} ticketSelectedCount={selectedTicket} templateId="default"></BankAccount>
              </Button>
            </Grid>
          ))
        }
      </Grid>

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="xl">
        <DialogTitle>Editar Cuenta Bancaria</DialogTitle>
        <DialogContent>
          {editedAccount && (
            <Grid container spacing={2} p={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" disabled>
                  <InputLabel>Banco</InputLabel>
                  <Select
                    value={editedAccount.bankId}
                    onChange={(e) =>
                    {
                      const foundedBank = banks.find(bank => bank.id === e.target.value)
                      if (foundedBank) {
                        setEditedAccount({ ...editedAccount, bank: foundedBank.name, bankId: foundedBank.id })
                      }
                    }
                    }
                    label="Banco"
                  >
                    {banks.map((bank) => (
                      <MenuItem key={bank.id} value={bank.id}>
                        <Box display="flex" alignItems="center">
                          {getIconFromBankId({
                            bankId: bank.id,
                            width: 20,
                            height: 20,
                          })}
                          <Typography sx={{ pl: 1 }}>{bank.name}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" disabled>
                  <InputLabel>Tipo de cuenta</InputLabel>
                  <Select
                    value={editedAccount.accountType}
                    onChange={(e) =>
                      setEditedAccount({ ...editedAccount, accountType: e.target.value })
                    }
                    label="Tipo de cuenta"
                  >
                    {[
                      "Cuenta Corriente",
                      "Cuenta RUT",
                      "Cuenta Vista",
                      "Cuenta de Ahorro",
                      "Nequi",
                      "Pago Móvil",
                    ].map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {[
                { disabled: true, field: "name", label: "Nombre" },
                { disabled: true, field: "dni", label: "DNI" },
                { disabled: true, field: "accountNumber", label: "Número de cuenta" },
                { disabled: false, field: "ticketPrice", label: "Precio (texto)" },
                { disabled: false, field: "ticketPriceAmount", label: "Precio (número)" },
                { disabled: true, field: "ticketCurrency", label: "Moneda" },
              ].map(({ disabled, field, label }) => (
                <Grid item xs={12} sm={6} key={field}>
                  <TextField
                    disabled={disabled}
                    label={label}
                    variant="outlined"
                    fullWidth
                    value={editedAccount[field as keyof BankAccountItem] || ""}
                    onChange={(e) =>
                      setEditedAccount({
                        ...editedAccount,
                        [field]: field === 'ticketPriceAmount' ? Number.parseInt(e.target.value) : e.target.value,
                      })
                    }
                    margin="normal"
                    type={field.includes("Amount") ? "number" : "text"}
                  />
                </Grid>
              ))}

              {editedAccount.conversion && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Precio del dólar"
                      variant="outlined"
                      fullWidth
                      value={editedAccount.conversion.dolarPrice}
                      onChange={(e) =>
                        setEditedAccount({
                          ...editedAccount,
                          conversion: {
                            ...editedAccount.conversion,
                            dolarPrice: Number.parseInt(e.target.value || "0"),
                          },
                        })
                      }
                      margin="normal"
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Moneda del dólar"
                      variant="outlined"
                      fullWidth
                      value={editedAccount.conversion.dolarPriceCurrency}
                      onChange={(e) =>
                        setEditedAccount({
                          ...editedAccount,
                          conversion: {
                            ...editedAccount.conversion,
                            dolarPriceCurrency: e.target.value || "",
                          },
                        })
                      }
                      margin="normal"
                      type="text"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveDialog} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
